"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var application_1 = require("../../models/application");
var constants = require("../../shared/code/Constants");
function view() {
    var _this = this;
    return {
        state: {
            actionItem: this.props.actionItem,
            parentTag: "",
            userYesNoId: "userYesNo",
            userAgreementId: "userAgreement",
            agreementText: this.props.DisclaimerIAgreeText,
            yesNoSelected: null,
            yesNoItems: [
                {
                    "value": "yes",
                    "label": this.props.DisclaimerYesText
                },
                {
                    "value": "no",
                    "label": this.props.DisclaimerNoText
                }
            ],
            constants: constants
        },
        initialize: function () {
            _this.view.helpers.prepopulate();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
            _this.view.helpers.returnResultsToPage();
        },
        receivedProps: function (nextProps) {
            _this.view.state.actionItem = nextProps.actionItem;
            _this.view.helpers.prepopulate();
            _this.view.helpers.returnResultsToPage();
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            userAnswerChanged: function (answer) {
                _this.view.state.actionItem.errorMessage = "";
                _this.view.state.actionItem.isAgreed = answer;
                _this.view.helpers.returnResultsToPage();
            },
            userYesNoChange: function (value, id) {
                _this.view.state.actionItem.errorMessage = "";
                _this.view.state.actionItem.isAgreed = (value === "yes");
                _this.view.state.yesNoSelected = value;
                _this.view.helpers.returnResultsToPage();
            }
        },
        helpers: {
            prepopulate: function () {
                _this.view.state.yesNoSelected = (_this.view.state.actionItem.isAgreed != undefined &&
                    _this.view.state.actionItem.isAgreed == true) ? "yes" : "no";
                _this.view.state.parentTag = _this.view.state.actionItem.type + "-" + _this.view.state.actionItem.id;
                _this.view.state.userAgreementId = "user-agreement-" + _this.view.state.actionItem.id;
                _this.view.state.userYesNoId = "user-yes-no-" + _this.view.state.actionItem.id;
            },
            returnResultsToPage: function () {
                var resultData = new application_1.DisclaimerResultData();
                resultData.actionId = _this.view.state.actionItem.id;
                resultData.type = application_1.ActionType.disclaimer;
                resultData.isAgreed = _this.view.state.actionItem.isAgreed;
                _this.props.onDataChanged(resultData);
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/ApplicationWorkflowDisclaimerAction/View.js
// module id = 609
// module chunks = 0